"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textFieldLabelStyle = exports.outlineInputStyle = exports.inputLabelStyle = void 0;
var _helpers = require("../../components/utils/helpers");
var _colors = require("../colors.config");
var inputLabelStyle = function inputLabelStyle(isFontBigger, isHighContrast) {
  return {
    outlined: {
      '&$shrink': {
        backgroundColor: isHighContrast ? _colors.Black[900] : 'white',
        marginLeft: 7,
        padding: '0 4px',
        transform: 'translate(16px, -8px) scale(0.777)'
      },
      fontSize: isFontBigger ? 21 : 18,
      transform: isFontBigger ? 'translate(25px, 18px)' : 'translate(25px, 16px)'
    },
    root: {
      color: isHighContrast ? _helpers.agentDeveloperUtils.getSecondaryColor(50) : _helpers.agentDeveloperUtils.getSecondaryColor(300),
      fontSize: isFontBigger ? 20 : 16,
      lineHeight: isFontBigger ? '22px' : '20px'
    },
    shrink: {}
  };
};
exports.inputLabelStyle = inputLabelStyle;
var textFieldLabelStyle = function textFieldLabelStyle(isFontBigger, isHighContrast) {
  return {
    root: {
      '&>.MuiFormLabel-root': {
        '&.MuiInputLabel-marginDense': {
          // default value for MaterialUI, set it to override styles below for small inputs
          transform: 'translate(14px, 12px) scale(1)'
        },
        '&.MuiInputLabel-shrink': {
          backgroundColor: 'transparent',
          marginLeft: 7,
          padding: 0,
          transform: 'translate(16px, -8px) scale(0.777)'
        },
        backgroundColor: 'transparent',
        fontSize: isFontBigger ? 21 : 18,
        padding: 0,
        transform: isFontBigger ? 'translate(25px, 18px)' : 'translate(25px, 16px)'
      },
      color: isHighContrast ? _helpers.agentDeveloperUtils.getSecondaryColor(50) : _helpers.agentDeveloperUtils.getSecondaryColor(300),
      fontSize: isFontBigger ? 20 : 16,
      lineHeight: isFontBigger ? '22px' : '20px'
    }
  };
};
exports.textFieldLabelStyle = textFieldLabelStyle;
var outlineInputStyle = function outlineInputStyle(isFontBigger, isHighContrast) {
  return {
    input: {
      color: isHighContrast ? _helpers.agentDeveloperUtils.getSecondaryColor(50) : _helpers.agentDeveloperUtils.getSecondaryColor(300),
      padding: '16px 25px'
    },
    root: {
      '& fieldset': {
        borderColor: _helpers.agentDeveloperUtils.getSecondaryColor(100)
      },
      '& input + fieldset': {
        borderColor: _helpers.agentDeveloperUtils.getSecondaryColor(100),
        borderWidth: 1
      },
      '& input:invalid + fieldset': {
        backgroundColor: isHighContrast ? 'rgba(255,0,0,.05)' : _colors.Red[50],
        borderColor: _colors.Red[200]
      },
      '& label': {
        transform: 'translate(20px, 20px) scale(1)'
      },
      '& label.MuiInputLabel-shrink': {
        transform: 'translate(20px, -6px) scale(0.75)'
      },
      '& legend': {
        fontSize: isFontBigger ? 21 : 18,
        marginLeft: 10
      },
      '& legend > span': {
        paddingLeft: 0,
        paddingRight: 0
      },
      '&.Mui-disabled em, &.Mui-disabled .MuiSvgIcon-root.MuiSelect-icon': {
        color: isHighContrast ? _colors.Black[100] : _colors.Black[150]
      },
      '&.Mui-disabled fieldset.MuiOutlinedInput-notchedOutline': {
        borderColor: isHighContrast ? _colors.Black[100] : _colors.Black[150]
      },
      '&.Mui-focused:hover fieldset.MuiOutlinedInput-notchedOutline': {
        borderColor: _helpers.agentDeveloperUtils.getPrimaryColor(450)
      },
      '&:hover': {
        '& fieldset.MuiOutlinedInput-notchedOutline': {
          borderColor: _helpers.agentDeveloperUtils.getSecondaryColor(100)
        },
        '&.Mui-disabled:hover fieldset.MuiOutlinedInput-notchedOutline': {
          borderColor: isHighContrast ? _colors.Black[100] : _colors.Black[150]
        }
      },
      '&[color="primary"] fieldset': {
        borderColor: _helpers.agentDeveloperUtils.getPrimaryColor(450),
        top: 0 /* legend is not displayed in this color */
      },

      '&[color="primary"] legend': {
        display: 'none'
      },
      '&[color="primary"].Mui-focused:hover fieldset.MuiOutlinedInput-notchedOutline': {
        borderColor: _helpers.agentDeveloperUtils.getPrimaryColor(450)
      },
      '&[color="primary"]:hover fieldset.MuiOutlinedInput-notchedOutline': {
        borderColor: _helpers.agentDeveloperUtils.getPrimaryColor(450)
      },
      borderRadius: 30
    }

    //  inputSelect: {
    //    fontSize: '16px',
    //    lineHeight: '20px',
    //    paddingRight: '35px'
    //  },
  };
};

exports.outlineInputStyle = outlineInputStyle;